// Global
export const WLOST_001 = 'Finaliser la création de votre compte';

// HTML titles
export const WHTML_005 = 'Initialisation du mot de passe | Mot de passe oublié Orange';
export const WHTML_007 = 'Confimation de création de mot de passe | Mot de passe oublié Orange';

// Login
export const WLOST_102 = 'Indiquez l\'adresse email ou le numéro de mobile du compte Orange dont vous souhaitez initialiser le mot de passe.';

// Choose contact
export const WLOST_201 = 'Recevez votre code d\'initialisation';

// Default contact OTC
export const WLOST_290 = `Nous vous proposons de vous envoyer par SMS un code d'initialisation au {defaultContact}.\nVous pourrez ensuite créer votre mot de passe de façon sécurisée.`;

// OTC
export const WLOST_301 = 'Votre code d\'initialisation du mot de passe a été envoyé au ';
export const WLOST_302 = 'Votre code d\'initialisation du mot de passe a été envoyé à ';
export const WLOST_305 = 'Ce code à 6 chiffres vous permet de créer votre mot de passe.';
export const WLOST_306 = 'Veuillez saisir le code d\'initialisation.';
export const WLOST_307 = 'Ce code d\'initialisation comporte uniquement des chiffres.';
export const WLOST_308 = 'Veuillez vérifier la saisie de votre code d\'initialisation.';

export const WLOST_331 = 'Vous avez atteint le maximum d’envois du code d\'initialisation de mot de passe par SMS.<br>Nous vous invitons à renouveler votre demande ultérieurement.';
export const WLOST_332 = 'Vous avez atteint le maximum d’envois du code d\'initialisation de mot de passe par email.<br>Nous vous invitons à renouveler votre demande ultérieurement.';
export const WLOST_335 = 'Le code d\'initialisation a expiré';
export const WLOST_336 = 'Le code d\'initialisation qui vous a été envoyé n’est plus valide.<br>Nous vous invitons à renouveler votre demande.';

// Change password
export const WLOST_418 = 'Création de votre mot de passe en cours';

// Popin
export const WLOST_621 = 'Comment s\'est passé la création de votre mot de passe ?\nDonnez votre avis et tentez de gagner un iPhone 11.';

export const WLOST_600 = 'Félicitations, votre compte Orange est créé.';